import ReactNative, { Platform } from 'react-native';
const { Variant } = ReactNative.NativeModules;

const variantName = (Variant && Variant.VARIANT_NAME) || 'standard';
export const variant = {
  name: variantName,
  isStandard: variantName === 'standard',
  isElite: variantName === 'elite',
};

const isWeb = Platform.OS === 'web';

const isHermesEngine = !!global.HermesInternal;  // restart metro when changing hermes in Android/iOS builds
const engine = {
  isHermes: isHermesEngine,
  name: isHermesEngine ? 'Hermes' : (isWeb ? 'web' : 'JSC'),
};

const build = {
  variant,
  engine,
  // todo: move other "static/const" type configs here
};
export default build;
